
import './App.css';
import {Home} from "./pages/home/Home"
// import { Watch } from './pages/watch/Watch';
// import { Register } from './pages/Register/Register';
// import { Login } from './pages/Login/Login';

function App() {
  return (
    <div className="App">
   <Home/>
    </div>
  );
}

export default App;
